import type { TReviews } from '@shared/common/data/products';
import Froebelkan from './Froebelkan';
import AlphabetTrain from './AlphabetTrain';
import MainichiKinenbi from './MainichiKinenbi';

const Books = [Froebelkan, AlphabetTrain, MainichiKinenbi];

export const fbBookAliasArr = Books.map((_) => _.alias);

export const Reviews = Books.reduce<TReviews>((arr, book) => {
  arr.push(...book.reviews);

  return arr;
}, []);

export default Books;
